// Value for the development:
//export const API_URL = "http://localhost:8090/";

//Value for the server setting: 
export const API_URL = "/api/";
export default API_URL;
